import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Container } from "reactstrap";

const Terms: React.FC = () => {
  const { t } = useTranslation("legal");
  return (
    <Container className="py-5 px-4 px-md-5 plainHtml bg-white">
      <Trans
        t={t}
        i18nKey={"terms"}
        components={{
          br: <br />,
          h1: <h1 />,
          h2: <h2 />,
          h3: <h3 />,
          h4: <h4 />,
          p: <p />,
          strong: <strong />,
          u: <u />,
          ul: <ul />,
          ol: <ol />,
          li: <li />,
          ol_type_a: <ol type="a" />,
          ol_type_A: <ol type="A" />,
          ol_type_I: <ol type="I" />,
          ol_type_i: <ol type="i" />,
          small: <small />,
          table: <table />,
          thead: <thead />,
          tbody: <tbody />,
          tr: <tr />,
          th: <th />,
          td: <td />,
        }}
      />
    </Container>
  );
};

export default Terms;
